import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class Logo extends Component {

  render() {
    let { linkPath, linkTitle, optionalClasses, isExternal } = this.props

    return isExternal
    ? (
      <a
        className={`logo${optionalClasses ? ' ' + optionalClasses : ''}`}
        href={linkPath}
        title={linkTitle ? linkTitle : "Locker Linked"}
      >
        <svg className="icon"><use xlinkHref="#logo" /></svg>
        <span className="logo-text">Locker Linked</span>
      </a>
    )
    : (
      <Link
        className={`logo${optionalClasses ? ' ' + optionalClasses : ''}`}
        to={linkPath}
        title={linkTitle ? linkTitle : "Locker Linked"}
      >
        <svg className="icon"><use xlinkHref="#logo" /></svg>
        <span className="logo-text">Locker Linked</span>
      </Link>
    )
  }
}

export default Logo



// WEBPACK FOOTER //
// ./src/components/Global/Logo.js